import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_generic_doc_approval_request_RowClass} from '../../../dbschema';

export class GenericDocApprovalRequestContainerModel extends BaseContainerModel {
  bl_fi_generic_doc_approval_request: bl_fi_generic_doc_approval_request_RowClass = new bl_fi_generic_doc_approval_request_RowClass();
}
